// Page "Notre atelier" — bloc etapes de fabrication.
// 2026-08-06 : section pinnee, la piste des etapes glisse HORIZONTALEMENT
// au fil du scroll vertical (une seule formule progress = f(scroll), une
// seule source de verite pour le translateX ET pour le point actif — voir
// base.css pour le detail du choix). Desactive sur mobile/reduced-motion,
// ou .atelier-etapes__mobile-list (liste statique, sans JS) prend le
// relai via CSS seule.
(function () {
  var pinWrap = document.querySelector('[data-atelier-pinwrap]');
  var track = document.querySelector('[data-atelier-track]');
  if (!pinWrap || !track) return;

  var dots = Array.prototype.slice.call(document.querySelectorAll('[data-atelier-progress] .atelier-etapes__progress-dot'));
  var ticking = false;

  function isActive() {
    return pinWrap.offsetParent !== null;
  }

  function update() {
    ticking = false;
    if (!isActive()) return;

    var totalScroll = pinWrap.offsetHeight - window.innerHeight;
    if (totalScroll <= 0) return;

    var rect = pinWrap.getBoundingClientRect();
    var progress = Math.min(Math.max(-rect.top / totalScroll, 0), 1);
    var maxTranslate = track.scrollWidth - window.innerWidth;
    track.style.transform = 'translateX(-' + Math.max(maxTranslate, 0) * progress + 'px)';

    if (dots.length > 1) {
      var activeIndex = Math.round(progress * (dots.length - 1));
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === activeIndex); });
    }
  }

  function requestUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  update();
})();
